import React, { Fragment, useContext, Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";

import { BrowserRouter } from "react-router-dom";
import { Context, ContextProvider } from "./context/Context";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { AppRouter } from "./routes";

const Loaderimg = () => {
  return (
    <div id="global-loader">
      <img
        src={require("./assets/images/loader.svg").default}
        className="loader-img"
        alt="Loader"
      />
    </div>
  );
};

const Root = () => {
  const { user } = useContext(Context);

  return (
    <Fragment>
      <ContextProvider>
        <BrowserRouter>
          <Suspense fallback={<Loaderimg />}>
            <ToastContainer
              position="top-center"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />

            <AppRouter user={user} />
          </Suspense>
        </BrowserRouter>
      </ContextProvider>
    </Fragment>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);
